export function parseDocumentCookie() {
  return document.cookie.split("; ").reduce<Record<string, string>>((result, cookie) => {
    const [key, value] = cookie.split("=")
    if (key && value) {
      result[key] = decodeURIComponent(value)
    }
    return result
  }, {})
}
